import { idToStrongId } from "@oysterhr/common"
import { generatePath } from "react-router-dom"
import { staffBasePath } from "../../utils/baseRoutes"

const _staffCompaniesBasePath = ({
  id,
  path,
  query,
  hash,
}: { id?: string; path?: string; query?: string; hash?: string } = {}) => {
  return staffBasePath({ scope: "companies", id, path, query, hash })
}
const _staffEquityGrantBasePath = ({
  scope,
  engagementId,
  grantId,
}: {
  scope: string
  engagementId: string
  grantId: string
}) => {
  return generatePath(":scope/:engagementId/equity/grant/:grantId", {
    scope,
    engagementId: idToStrongId(engagementId),
    grantId: idToStrongId(grantId),
  })
}

export const staffCompaniesPath = () => _staffCompaniesBasePath()

export const staffCompanyPath = (id: string, hash?: string) => _staffCompaniesBasePath({ id, hash })

export const staffCompanyProfilePath = (id: string) =>
  staffBasePath({ scope: "company", id, path: "profile" })

export const staffCompanyDocumentsPath = (id: string) =>
  staffBasePath({ scope: "company", id, path: "documents" })

export const staffEngagementsPath = () => staffBasePath({ scope: "engagements" })

export const staffEngagementPath = (companyId: string, engagementId: string, tab?: string) =>
  _staffCompaniesBasePath({
    id: companyId,
    path: `employments/${idToStrongId(engagementId)}`,
    hash: tab,
  })

export const staffContractorPath = (companyId: string, engagementId: string) =>
  _staffCompaniesBasePath({
    id: companyId,
    path: `contractors/${idToStrongId(engagementId)}`,
  })

export const staffOffboardingFlowPath = (companyId: string, employmentId: string) =>
  _staffCompaniesBasePath({
    id: companyId,
    path: `employments/${idToStrongId(employmentId)}/offboarding`,
  })

export const staffOffboardingTabPath = (companyId: string, employmentId: string) =>
  _staffCompaniesBasePath({
    id: companyId,
    path: `employments/${idToStrongId(employmentId)}`,
    hash: "offboarding",
  })

export const staffEngagementTemplateExportPath = (engagementStrongId: string) =>
  `/engagements/${idToStrongId(engagementStrongId)}/export`

export const staffEquityGrantDetailsPath = (
  companyId: string,
  engagementId: string,
  grantId: string,
) => {
  const path = _staffEquityGrantBasePath({
    scope: "employments",
    engagementId: idToStrongId(engagementId),
    grantId: idToStrongId(grantId),
  })

  return _staffCompaniesBasePath({ id: companyId, path })
}

export const staffEquityGrantDetailsToContractorPath = (
  companyId: string,
  engagementId: string,
  grantId: string,
) => {
  const path = _staffEquityGrantBasePath({
    scope: "contractors",
    engagementId: idToStrongId(engagementId),
    grantId: idToStrongId(grantId),
  })

  return _staffCompaniesBasePath({ id: companyId, path })
}

export const staffCompaniesBulkProcessingPath = (companyId: string) =>
  _staffCompaniesBasePath({
    id: companyId,
    path: "bulk-processing",
  })

export const staffCompaniesBulkProcessingResultPath = (
  companyId: string,
  bulkProcessingId: string,
) =>
  _staffCompaniesBasePath({
    id: companyId,
    path: `bulk-processing/${idToStrongId(bulkProcessingId)}/result`,
  })
